export default "__VITE_PUBLIC_ASSET__794f7ef7__"